export enum TableComponentStateEnum {
    ERROR,
    LOADING,
    REFRESHING,
    SUCCESS,
}
